// src/icons/ReceivableIcon.tsx
import React from "react";

export function ReceivableIcon({
  className = "",
  ...props
}: React.SVGProps<SVGSVGElement> & { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {/* Dollar sign */}
      <path d="M16 8.5c0-2-1.79-3-4-3s-4 1-4 3c0 2 1.5 3 4 4s4 2 4 4c0 2-1.79 3-4 3s-4-1-4-3" />
      <line x1="12" y1="4" x2="12" y2="21" />

      {/* Arrow pointing toward dollar sign from right */}
      <line x1="28" y1="12" x2="20" y2="12" />
      <polyline points="22,10 20,12 22,14" />
    </svg>
  );
}
